module.exports = __webpack_public_path__ + "img/call.1f0c64bd.svg";